import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    }; 
  return (
        <>
        <footer className="main-footer">
            <div className="main-footer__bg" style={{ backgroundImage: 'url(assets/images/shapes/footer-bg-1-1.png)' }}></div>
            <div className="main-footer__shape" style={{ backgroundImage: 'url(assets/images/shapes/footer-1-shape-1.png)' }}></div>

            <div className="main-footer__top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-xl-3">
                            <div className="footer-widget footer-widget--about">
                                <Link to="/" className="footer-widget__logo">
                                    <img src="assets/images/logo-light.png" width="160" alt="Logo" />
                                </Link>
                                <p className="footer-widget__text">
                                    We build smart digital solutions that drive growth and results.
                                </p>
                                <Link className="growim-btn growim-btn--white" to="/contact">
                                    <span className="growim-btn__text">Contact Us</span>
                                    <span className="growim-btn__icon"><i className="flaticon-up-right-arrow"></i></span>
                                </Link>
                                <div className="footer-widget__social">
                                    <p className="footer-widget__social__text">Follow on</p>
                                    <Link to="https://www.facebook.com/consultantdigitalkoushik">
                                        <i className="fab fa-facebook-f" aria-hidden="true"></i>
                                        <span className="sr-only">Facebook</span>
                                    </Link>
                                   
                                    <Link to="https://www.linkedin.com/in/digitalkoushik/">
                                        <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                                        <span className="sr-only">Linkedin</span>
                                    </Link>
                                   
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-2">
                            <div className="footer-widget">
                                <h2 className="footer-widget__title">Quick Link</h2>
                                 <ul className="list-unstyled footer-widget__links">
                                    <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                                    <li><Link to="/about" onClick={scrollToTop}>About</Link></li>
                                    <li><Link to="/why-choose-us" onClick={scrollToTop}>Why Choose Us</Link></li>
                                    <li><Link to="/portfolio" onClick={scrollToTop}>Portfolio</Link></li>
                                    <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>                                    
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3">
                            <div className="footer-widget footer-widget--links">
                                <h2 className="footer-widget__title">our services</h2>
                                <ul className="list-unstyled footer-widget__links">
                                    <li><Link to="/services" onClick={scrollToTop}>Web Application Development</Link></li>
                                    <li><Link to="/services" onClick={scrollToTop}>Mobile App Development</Link></li>
                                    <li><Link to="/services" onClick={scrollToTop}>Social Media Marketing</Link></li>
                                    <li><Link to="/services" onClick={scrollToTop}>Creative Design services</Link></li>
                                    <li><Link to="/services" onClick={scrollToTop}>Brand Building & Promotion</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4">
                            <div className="footer-widget footer-widget--contact">
                                <h2 className="footer-widget__title">contact us</h2>
                                <ul className="list-unstyled footer-widget__info">
                                    <li><i className="flaticon-pin"></i>32/7A, Nabanagar, Vidyasagar Park, Birati, Kolkata, West Bengal 700051, India</li>
                                    <li><i className="flaticon-phone"></i><Link to="tel:+91 84788 61990">+91 84788 61990</Link></li>
                                    <li><i className="flaticon-email"></i><Link to="mailto:info@gmail.com">contact@digitalkoushik.com</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-footer__bottom">
                <div className="container">
                    <div className="main-footer__bottom__inner">
                        <p className="main-footer__copyright">
                            &copy; Copyright <span className="dynamic-year">{currentYear}</span> by Digitalkoushik.
                        </p>
                    </div>
                </div>
            </div>
        </footer> 
        </>
  )
}

export default Footer